export default __webpack_public_path__ + "static/Cala-Macarella-Menorca-credit-DavidBurillo-c8420a6ac99034e317b36b16d8c04525.jpg";